<template>
  <span>
    <b-btn
        @click="$emit('click', $event)"
        :block="block"
        :disabled="disabled"
        :size="size"
        :variant="variant"
        :type="type"
        :tag="tag"
        :pill="pill"
        :squared="squared"
        :pressed="pressed"
      >
        <b-spinner class="spinner-button-spinner" v-show="busy" small></b-spinner>
        <span v-show="busy" class="sr-only">Loading...</span>
        <span v-show="!busy">
          <slot></slot>
        </span>
    </b-btn>
  </span>
</template>

<script>
export default {
  name: 'SpinnerButton',
  props: {
    busy: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
    },
    variant: {
      type: String,
    },
    type: {
      type: String,
      default: 'button'
    },
    tag: {
      type: String,
      default: 'button'
    },
    pill: {
      type: Boolean,
      default: false
    },
    squared: {
      type: Boolean,
      default: false
    },
    pressed: {
      type: Boolean,
      default: null
    }
  },
}
</script>

<style scoped>
.spinner-button-spinner {
  margin-bottom: 5px;
}
</style>
